import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { trialBalanceReport } from "../../../services/accounts";
import { exportPDF, exportExcel } from "./exportUtils";

const GROUP_TYPE_ORDER = ["Asset", "Liability", "Income", "Expense", "Capital"];

export default function TrialBalance() {
  const [toDate, setToDate]   = useState(moment().format("YYYY-MM-DD"));
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  function handleSearch() {
    setLoading(true);
    const temp = new FormData();
    temp.append("to_date", toDate);
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    trialBalanceReport(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
    });
  }

  const grouped = data
    ? GROUP_TYPE_ORDER.reduce((acc, type) => {
        acc[type] = data.rows.filter((r) => r.group_type === type);
        return acc;
      }, {})
    : {};

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Trial Balance</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active" aria-current="page">Trial Balance</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">As on Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <a onClick={handleSearch} className="btn btn-success">
                        {loading ? "Loading..." : "Show"}
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Trial Balance as on {moment(data.to_date).format("DD MMM YYYY")}</h5>
                  <div>
                    <a onClick={() => {
                      const cols = ["Ledger", "Group", "Debit (Dr)", "Credit (Cr)"];
                      const rows = (data.rows || []).map((r) => [r.ledger_name, r.group_name,
                        r.closing_dr > 0 ? r.closing_dr.toFixed(2) : "",
                        r.closing_cr > 0 ? r.closing_cr.toFixed(2) : ""]);
                      exportPDF(`Trial Balance - ${moment(data.to_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-danger btn-sm me-2">
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a onClick={() => {
                      const cols = ["Ledger", "Group", "Debit (Dr)", "Credit (Cr)"];
                      const rows = (data.rows || []).map((r) => [r.ledger_name, r.group_name,
                        r.closing_dr > 0 ? r.closing_dr.toFixed(2) : "",
                        r.closing_cr > 0 ? r.closing_cr.toFixed(2) : ""]);
                      exportExcel(`Trial Balance - ${moment(data.to_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-success btn-sm">
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
                      <tr>
                        <th>Ledger</th>
                        <th>Group</th>
                        <th className="text-end">Debit (Dr)</th>
                        <th className="text-end">Credit (Cr)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {GROUP_TYPE_ORDER.map((type) =>
                        grouped[type]?.length > 0 ? (
                          <React.Fragment key={type}>
                            <tr>
                              <td colSpan={4}><strong>{type}</strong></td>
                            </tr>
                            {grouped[type].map((row, i) => (
                              <tr key={i}>
                                <td className="ps-4">{row.ledger_name}</td>
                                <td>{row.group_name}</td>
                                <td className="text-end">{row.closing_dr > 0 ? row.closing_dr.toFixed(2) : ""}</td>
                                <td className="text-end">{row.closing_cr > 0 ? row.closing_cr.toFixed(2) : ""}</td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ) : null
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="fw-bold">
                        <td colSpan={2}>Grand Total</td>
                        <td className="text-end">{data.grand_dr?.toFixed(2)}</td>
                        <td className="text-end">{data.grand_cr?.toFixed(2)}</td>
                      </tr>
                      {Math.abs(data.grand_dr - data.grand_cr) < 0.01 ? (
                        <tr>
                          <td colSpan={4} className="text-center text-success fw-bold">
                            <i className="fa fa-check-circle me-1" /> Balanced
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center text-danger fw-bold">
                            <i className="fa fa-exclamation-circle me-1" />
                            Difference: {Math.abs(data.grand_dr - data.grand_cr).toFixed(2)}
                          </td>
                        </tr>
                      )}
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
